import { MoveGenerator } from '../../../jscaip/AI/AI';
export class ReversiMoveGenerator extends MoveGenerator {
    rules;
    constructor(rules) {
        super();
        this.rules = rules;
    }
    getListMoves(node, config) {
        const moves = this.rules.getListMoves(node.gameState, config);
        return moves.map((moveWithSwitched) => {
            return moveWithSwitched.move;
        });
    }
}
